<script setup>
const asset = (path) => `${import.meta.env.BASE_URL}${path}`

const winners = [
  { name: 'Ruby****', game: 'Luky Jack', amount: '$1,360.95', image: 'providers/game-1.png' },
  { name: 'Gama****', game: 'Lady Wolf Moon', amount: '$960.50', image: 'providers/game-6.png' },
  { name: 'Brok****', game: '7 Lucky Dwarf', amount: '$2,593.09', image: 'providers/game-11.png' },
  { name: 'Hiza****', game: 'The Dog House', amount: '$5,205.47', image: 'providers/game-13.png' },
  { name: 'Rima****', game: 'Luky Jack', amount: '$1,408.32', image: 'providers/game-4.png' },
]
</script>

<template>
  <section class="winners-now" aria-labelledby="winners-now-title">
    <div class="winners-now__inner">
      <h2 id="winners-now-title" class="winners-now__title">
        Wining right now
        <span aria-hidden="true"></span>
      </h2>

      <div class="winners-now__row">
        <img class="winners-now__coin" :src="asset('wrn/wrn-coin.png')" alt="" aria-hidden="true" />

        <div class="winners-now__list">
          <article
            v-for="(winner, index) in winners"
            :key="`${winner.name}-${index}`"
            class="winners-now__card"
            :class="{ 'winners-now__card--active': index === 0 }"
          >
            <img class="winners-now__game-img" :src="asset(winner.image)" alt="" aria-hidden="true" />
            <div class="winners-now__card-copy">
              <h3>{{ winner.name }}</h3>
              <p>{{ winner.game }}</p>
              <strong>{{ winner.amount }}</strong>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.winners-now {
  width: 100%;
  
}

.winners-now__inner {
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 0 16px 32px;
  padding-right: 0;
  
}

.winners-now__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 18px;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
}

.winners-now__title span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #ee142d;
  animation: blink 1.2s infinite;
}

@keyframes blink {
  0%, 49% {
    opacity: 1;
  }
  50%, 100% {
    opacity: 0.3;
  }
}

.winners-now__row {
  position: relative;
  min-height: 196px;
}

.winners-now__row::before {
  position: absolute;
  top: 56px;
  right: 0;
  left: 58px;
  height: 116px;
  content: '';
  background: var(--gradient-winners-bg);
}

.winners-now__row::after {
  position: absolute;
  top: 56px;
  right: 0;
  z-index: 3;
  width: 72px;
  height: 116px;
  content: '';
  background: linear-gradient(90deg, rgb(0 0 24 / 0) 0%, var(--color-page-bg) 82%);
  
  pointer-events: none;
}

.winners-now__coin {
  position: absolute;
  top: 38px;
  left: -52px;
  z-index: 4;
  width: 152px;
  height: 152px;
  object-fit: contain;
  transform-origin: center;
  animation: winners-now-coin-spin 5.6s ease-in-out infinite;
  will-change: transform;
}

@keyframes winners-now-coin-spin {
  0%,
  68%,
  100% {
    transform: rotate(0deg) scale(1);
  }

  76% {
    transform: rotate(180deg) scale(1.05);
  }

  84% {
    transform: rotate(360deg) scale(1);
  }
}

.winners-now__list {
  position: absolute;
  top: 78px;
  right: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 82px;
  overflow-x: auto;
  padding: 0 0 2px 64px;
  scrollbar-width: none;
}

.winners-now__list::-webkit-scrollbar {
  display: none;
}

.winners-now__card {
  display: grid;
  grid-template-columns: 48px minmax(96px, 1fr);
  flex: 0 0 196px;
  align-items: center;
  gap: 12px;
  min-height: 72px;
  padding: 10px;
  border: 1px solid rgb(255 140 0 / 0.1);
  border-radius: 12px;
  background: rgb(26 6 30 / 0.84);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.winners-now__card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 140, 0, 0.4);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.22);
  background: rgba(26, 6, 30, 0.95);
}

.winners-now__card--active {
  border-color: var(--color-accent);
}

.winners-now__game-img {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
}

.winners-now__card-copy {
  min-width: 0;
}

.winners-now__card-copy h3,
.winners-now__card-copy p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.winners-now__card-copy h3 {
  margin: 0 0 4px;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.1;
}

.winners-now__card-copy p {
  margin: 0 0 6px;
  color: rgb(255 255 255 / 0.52);
  font-size: 0.82rem;
  line-height: 1.1;
}

.winners-now__card-copy strong {
  display: block;
  overflow: hidden;
  color: var(--color-gold);
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .winners-now__inner {
    padding: 0 48px 44px;
    padding-right: 0;
  }

  .winners-now__title {
    margin-bottom: 24px;
    font-size: 1.5rem;
  }

  .winners-now__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    min-height: 190px;
    padding: 18px 22px;
    padding-left: 0;
  }

  .winners-now__row::before {
    top: 36px;
    left: 104px;
    height: 120px;
  }

  .winners-now__row::after {
    top: 36px;
    width: 120px;
    height: 120px;
  }

  .winners-now__coin {
    position: relative;
    top: auto;
    left: auto;
    flex: 0 0 152px;
  }

  .winners-now__list {
    position: relative;
    top: auto;
    right: auto;
    left: auto;
    flex: 1 1 auto;
    height: auto;
    gap: 12px;
    padding: 0 0 2px;
  }

  .winners-now__card {
    grid-template-columns: 52px minmax(118px, 1fr);
    flex-basis: 214px;
  }

  .winners-now__game-img {
    width: 52px;
    height: 52px;
  }

  .winners-now__card-copy h3 {
    font-size: 1rem;
  }

  .winners-now__card-copy p {
    font-size: 0.88rem;
  }

  .winners-now__card-copy strong {
    font-size: 1.1rem;
  }
}
</style>
